import React, { useState } from "react";
import { X } from "lucide-react";
import { products, WHATSAPP_LINK } from "../../mock";

const Galeria = () => {
  const [selected, setSelected] = useState(null);
  const images = products.map((p) => ({ src: p.image, name: p.name }));

  return (
    <section id="galeria" className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5">
        <div className="text-center">
          <span className="text-sm font-bold tracking-[0.2em] text-[#ec4899] uppercase">
            Galeria
          </span>
          <h2 className="mt-4 font-display font-bold text-white text-3xl md:text-5xl leading-tight">
            Momentos de pura alegria
          </h2>
          <p className="mt-6 text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed">
            Veja um pouquinho da diversão que levamos para cada evento.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {images.map((img, i) => (
            <button
              key={i}
              onClick={() => setSelected(img.src)}
              className="group relative overflow-hidden rounded-3xl bg-black border border-white/10 hover:border-[#ec4899]/40 transition-colors"
            >
              <img
                src={img.src}
                alt={img.name}
                loading="lazy"
                className="w-full h-auto block transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selected && (
        <div
          className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm flex items-center justify-center p-5"
          onClick={() => setSelected(null)}
        >
          <button
            className="absolute top-6 right-6 text-white/80 hover:text-white"
            onClick={() => setSelected(null)}
            aria-label="Fechar"
          >
            <X size={32} />
          </button>
          <img
            src={selected}
            alt="Evento"
            className="max-h-[85vh] max-w-full rounded-2xl shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      {/* CTA band */}
      <div className="max-w-7xl mx-auto px-5 mt-16">
        <div className="relative overflow-hidden rounded-[2rem] bg-gradient-to-br from-[#ec4899] via-[#d6336c] to-[#8b5cf6] p-10 md:p-14 text-center">
          <div className="pointer-events-none absolute -top-10 -right-10 w-60 h-60 rounded-full bg-white/10 blur-2xl" />
          <h3 className="font-display font-bold text-white text-2xl md:text-4xl leading-tight">
            Vamos deixar a sua festa inesquecível?
          </h3>
          <p className="mt-4 text-white/90 text-lg max-w-xl mx-auto">
            Fale com a gente agora e garanta a diversão da criançada.
          </p>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            className="mt-8 inline-flex items-center justify-center rounded-full bg-white text-[#d6336c] font-extrabold text-base px-10 py-4 shadow-xl transition-all hover:-translate-y-0.5"
          >
            PEDIR ORÇAMENTO
          </a>
        </div>
      </div>
    </section>
  );
};

export default Galeria;
